export const addLogin = (id, name, email, userName, role, token) => {
  return {
    type: "user/login",
    payload: {
      id,
      name,
      email,
      userName,
      role,
      token,
    },
  };
};
